<template>
  <div>
    <!-- 顶部面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 设备信息 -->
    <div class="equipment-info bg-white pdl-20 pdt-10 pdb-20">
      <div class="color4272ea fw-600 mgb-20">设备信息</div>
      <div class="color1010 mgb-20">
        <span class="mgr-150">设备型号：##</span>
        <span class="mgr-150">设备编号：##</span>
        <span class="mgr-150">设备类型：购买</span>
        <span class="mgr-150">设备归属：##企业</span>
      </div>
      <div class="color1010 mgb-20">
        <span class="mgr-45">划拨时间：2022-09-09 12：12</span>
        <span class="mgr-150">铺设天数：66</span>
        <span class="mgr-95">购水模式：扫码零售购水</span>
        <span class="mgr-150">联网状态：在线</span>
      </div>
      <div class="color1010 mgb-20">
        <span class="mgr-52">设备模式：常温、冰水、热水</span>
        <span class="mgr-110">设备运行状态：启用</span>
        <span class="mgr-150">设备位置：成都市</span>
      </div>
      <div class="color1010 mgb-20 flex fdc">
        <span class="mgb-5">出水量及价格：</span>
        <span class="mgb-5"
          >常温：250ml（0.5元）、250ml（0.5元）、250ml（0.5元）</span
        >
        <span class="mgb-5"
          >冰水：250ml（0.5元）、250ml（0.5元）、250ml（0.5元）</span
        >
        <span class="mgb-5"
          >热水：250ml（0.5元）、250ml（0.5元）、250ml（0.5元）</span
        >
      </div>
      <div class="flex">
        <div class="flex aic mgr-150">
          <span class="mgr-20">设备照片</span>
          <div class="img-placeholder">
            <img v-if="equipmentSrc" :src="equipmentSrc" alt="" />
            <i v-else class="el-icon-picture-outline"></i>
          </div>
        </div>
        <div class="flex aic">
          <span class="mgr-20">设备二维码</span>
          <div class="img-placeholder">
            <img v-if="qrSrc" :src="qrSrc" alt="" />
            <i v-else class="el-icon-picture-outline"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- 订单信息 -->
    <div class="order-info bg-white pdl-20 pdt-10 pdb-20 mgt-10">
      <div class="color4272ea fw-600 mgb-20">订单信息</div>
      <div class="color1010">
        <span class="mgr-100">设备订单量：666笔</span>
        <span>设备交易金额：666.66元</span>
      </div>
    </div>

    <!-- 设备滤芯状态 -->
    <div class="cto-state bg-white pdl-20 pdt-10 pdb-20 mgt-10">
      <div class="color4272ea fw-600 mgb-20">设备滤芯状态</div>
      <div class="ppc">
        <span class="color1010 mgr-20">PPC复合滤芯</span>
        <div class="ppcdata mgr-50">剩余90%</div>
        <div class="ppcdata">剩余使用时间约为##个月</div>
      </div>
      <div class="ro">
        <span class="color1010 mgr-13">RO反渗透滤芯</span>
        <div class="rodata mgr-50">剩余90%</div>
        <div class="rodata">剩余使用时间约为##个月</div>
      </div>
      <div class="pcb">
        <span class="color1010 mgr-20">PCB复合滤芯</span>
        <div class="pcbdata mgr-50">剩余90%</div>
        <div class="pcbdata">剩余使用时间约为##个月</div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      equipmentSrc: "", //设备照片
      qrSrc: "", //设备二维码照片
    };
  },
};
</script>

<style lang="scss" scoped>
// 图片占位
.img-placeholder {
  width: 100px;
  height: 100px;
  background-color: #e8e8e8;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    z-index: 999;
  }
  i {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px;
  }
}
// 设备滤芯状态
// ppc
.ppc {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  .ppcdata {
    padding: 5px 150px 5px 5px;
    border: 1px solid var(--input-border);
    color: var(--text-muted);
  }
}
// ro
.ro {
  display: flex;
  align-items: center;
  margin-bottom: 30px;

  .rodata {
    padding: 5px 150px 5px 5px;
    border: 1px solid var(--input-border);
    color: var(--text-muted);
  }
}
// pcb
.pcb {
  display: flex;
  align-items: center;
  .pcbdata {
    padding: 5px 150px 5px 5px;
    border: 1px solid var(--input-border);
    color: var(--text-muted);
  }
}
</style>
